import moment from "moment/moment";
import { useState, useEffect } from "react";
import { MapMissionTasks } from "../common/mission";
import { MissionEnums, TaskEnums } from "../common/constants";
import { Compare, useEntities } from "@emberly/zenith-client";


const query = {
  name: "active_or_completed_filter",
  or: [
    {
      path: "state",
      comparer: Compare.EQ,
      value: MissionEnums.State.Created
    },
    {
      and: [
        {
          path: "state",
          comparer: Compare.EQ,
          value: MissionEnums.State.Completed
        },
        {
          path: "lastModified",
          comparer: Compare.GTE,
          value: moment().startOf("day").toDate()
        },
      ]
    }
  ]
};


export function useDispatchTasks() {
  const [initialLoad, setInitialLoad] = useState(false);
  const [activeTasks, setActiveTasks] = useState([]);
  const [completedTasks, setCompletedTasks] = useState([]);

  
  const { entities, loading } = useEntities("Mission", query);

  useEffect(() => {
    if (!loading) {

      const update = () => {
        const tasks = entities.flatMap(t => MapMissionTasks(t));
        const startOfDay = moment().startOf("day").toDate();

        setActiveTasks(tasks.filter(t => t.state < TaskEnums.State.Completed && t.missionState === MissionEnums.State.Created).reverse())
        setCompletedTasks(tasks.filter(t => t.state >= TaskEnums.State.Completed && moment(t.execution.history?.completed?.created).toDate() >= startOfDay).reverse());
        setInitialLoad(true);
      }

      update();

      const timer = setInterval(update, 1000 * 60);

      return () => {
        clearInterval(timer);
      };
    }
  }, [entities, loading]);

  return {
    loading,
    initialLoad,
    activeTasks,
    completedTasks,
    entities
  };
}